export const propertyConstants = {
    PROPERTY_REQUEST:   'USERS_PROPERTY_REQUEST',
    PROPERTY_SUCCESS:   'USERS_PROPERTY_SUCCESS',
    PROPERTY_FAILURE:   'USERS_PROPERTY_FAILURE',

    GETALL_REQUEST:     'USERS_GETALL_REQUEST',
    GETALL_SUCCESS:     'USERS_GETALL_SUCCESS',
    GETALL_FAILURE:     'USERS_GETALL_FAILURE',
};
